import utilsBasic from 'helpers/utils.basic';
import utilsConstants from 'helpers/utils.constants';

const utils = {
  ...utilsBasic,
  ...utilsConstants
}

export default utils;
